import { BrowserRouter } from "react-router-dom";
import "./App.css";
import Footer from "./components/Footer/Footer";
import AppRoutes from "./routes/AppRoutes";
import AutoLogoutWrapper from "./components/AutoLogoutWrapper/AutoLogoutWrapper";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AutoLogoutWrapper>
          <main>
            <AppRoutes />
          </main>
          <Footer />
        </AutoLogoutWrapper>
      </BrowserRouter>
    </div>
  );
}

export default App;
